import { Box } from "@mui/material";

export function BlockedCheck(){
    return <Box sx={{height:"19px",width:"19px",marginLeft:"3px",border:"2px solid #D4D4D4",borderRadius:"3px",display:"flex",justifyContent:"center",alignItems:"center"}}>
        <Box sx={{backgroundColor:"#2B6ED4",borderRadius:"1px",height:"50%",width:"50%"}}></Box>
    </Box>
}